import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import InputBox from './InputBox';
import InputField from './InputField';

var Input = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Input, _Component);

  function Input() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "setInputNode", function (node) {
      _this.inputNode = node;
    });

    return _this;
  }

  var _proto = Input.prototype;

  _proto.focus = function focus() {
    this.inputNode.focus();
  };

  _proto.blur = function blur() {
    this.inputNode.blur();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        backgroundColor = _this$props.backgroundColor,
        color = _this$props.color,
        autoComplete = _this$props.autoComplete,
        autoFocus = _this$props.autoFocus,
        autoWidth = _this$props.autoWidth,
        defaultValue = _this$props.defaultValue,
        disabled = _this$props.disabled,
        focus = _this$props.focus,
        hover = _this$props.hover,
        id = _this$props.id,
        min = _this$props.min,
        minLength = _this$props.minLength,
        max = _this$props.max,
        maxLength = _this$props.maxLength,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onKeyDown = _this$props.onKeyDown,
        onKeyUp = _this$props.onKeyUp,
        placeholder = _this$props.placeholder,
        placeholderColor = _this$props.placeholderColor,
        readOnly = _this$props.readOnly,
        highlightOnInteraction = _this$props.highlightOnInteraction,
        type = _this$props.type,
        value = _this$props.value,
        required = _this$props.required,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["backgroundColor", "color", "autoComplete", "autoFocus", "autoWidth", "defaultValue", "disabled", "focus", "hover", "id", "min", "minLength", "max", "maxLength", "name", "onBlur", "onChange", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "placeholderColor", "readOnly", "highlightOnInteraction", "type", "value", "required"]);

    var ariaLabel = restProps['aria-label'];

    if (ariaLabel) {
      delete restProps['aria-label'];
    }

    return /*#__PURE__*/React.createElement(InputBox, _extends({
      disabled: disabled,
      backgroundColor: backgroundColor,
      color: color,
      focus: focus,
      hover: hover
    }, restProps), /*#__PURE__*/React.createElement(InputField, {
      "aria-label": ariaLabel,
      width: "100%",
      textOverflow: "ellipsis",
      innerRef: this.setInputNode,
      backgroundColor: "transparent",
      color: "inherit",
      id: id,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      autoWidth: autoWidth,
      type: type,
      name: name,
      disabled: disabled,
      readOnly: readOnly,
      highlightOnInteraction: highlightOnInteraction,
      placeholder: placeholder,
      placeholderColor: placeholderColor,
      defaultValue: defaultValue,
      min: min,
      minLength: minLength,
      max: max,
      maxLength: maxLength,
      value: value,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      required: required
    }));
  };

  return Input;
}(Component);

export default Input;